import {
  k4 as toSet,
  s9 as THROW_CCE,
  b6 as isCharSequence,
  d9 as trim,
  r6 as toString,
  f7 as Regex,
  e1 as ArrayList,
  s2 as joinToString,
  g7 as StringBuilder,
  n5 as charSequenceLength,
  v2 as joinTo,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function removeClass(_this__u8e3s4, cssClasses) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var inductionVariable = 0;
    var last = cssClasses.length;
    while (inductionVariable < last) {
      var element = cssClasses[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlinx.dom.removeClass.<anonymous>' call
      if (hasClass(_this__u8e3s4, element)) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  if (tmp$ret$1) {
    var toBeRemoved = toSet(cssClasses);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.text.split' call
    // Inline function 'kotlin.text.trim' call
    var tmp0_trim = _this__u8e3s4.className;
    var tmp1_split = toString(trim(isCharSequence(tmp0_trim) ? tmp0_trim : THROW_CCE()));
    // Inline function 'kotlin.text.toRegex' call
    var tmp3_filter = Regex.hb('\\s+').wb(tmp1_split, 0);
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp3_filter.u();
    while (tmp0_iterator.h1()) {
      var element_0 = tmp0_iterator.j1();
      // Inline function 'kotlinx.dom.removeClass.<anonymous>' call
      if (!toBeRemoved.w(element_0)) {
        tmp0_filterTo.e1(element_0);
      }
    }
    _this__u8e3s4.className = joinToString(tmp0_filterTo, ' ');
    return true;
  }
  return false;
}
function addClass(_this__u8e3s4, cssClasses) {
  // Inline function 'kotlin.collections.filterNot' call
  // Inline function 'kotlin.collections.filterNotTo' call
  var tmp0_filterNotTo = ArrayList.i4();
  var inductionVariable = 0;
  var last = cssClasses.length;
  while (inductionVariable < last) {
    var element = cssClasses[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlinx.dom.addClass.<anonymous>' call
    if (!hasClass(_this__u8e3s4, element)) {
      tmp0_filterNotTo.e1(element);
    }
  }
  var missingClasses = tmp0_filterNotTo;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!missingClasses.y()) {
    // Inline function 'kotlin.text.trim' call
    var tmp0_trim = _this__u8e3s4.className;
    var presentClasses = toString(trim(isCharSequence(tmp0_trim) ? tmp0_trim : THROW_CCE()));
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder.qa();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.dom.addClass.<anonymous>' call
    tmp0_apply.a8(presentClasses);
    // Inline function 'kotlin.text.isEmpty' call
    if (!(charSequenceLength(presentClasses) === 0)) {
      tmp0_apply.a8(' ');
    }
    joinTo(missingClasses, tmp0_apply, ' ');
    _this__u8e3s4.className = tmp0_apply.toString();
    return true;
  }
  return false;
}
function hasClass(_this__u8e3s4, cssClass) {
  // Inline function 'kotlin.text.matches' call
  var tmp1_matches = _this__u8e3s4.className;
  // Inline function 'kotlin.text.toRegex' call
  var tmp0_toRegex = '(^|.*\\s+)' + cssClass + '($|\\s+.*)';
  return Regex.hb(tmp0_toRegex).ib(tmp1_matches);
}
//region block: exports
export {
  addClass as a,
  removeClass as b,
};
//endregion

//# sourceMappingURL=kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat.mjs.map
